import React from "react";
import Page from "../../Components/Page";
import {Breadcrumbs} from "../../Components/Breadcrumbs";
import {useServiceBase} from "../../Components/ReactTable/useServiceBase";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import ReactTable from "../../Components/ReactTable";

function MAPEnforcementDashboard() {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/enforcementDashboard/`;
    const { loading, data} = useServiceBase({ endpointUrl });

    const customColumns = [
        {
            header: "Actions",
            id: "asin_list",
            filterable: true,
            accessorKey: "brand_name",
            cell: ({ row }) => <a href={"/mapAsins/"+row.original.brand_id+"?brandName="+row.original.brand_name} target="_blank" rel="noopener noreferrer">ASINs</a>,
            size: 50
        },
        {
            header: "Brand Id",
            filterable: true,
            accessorKey: "brand_id",
        },
        {
            header: "Brand Name",
            id: "brand_name",
            filterable: true,
            accessorKey: "brand_name",
            cell: ({ row }) => <a href={"/clientDashboard/"+row.original.brand_id+"?brandName="+row.original.brand_name} target="_blank" rel="noopener noreferrer">{row.original.brand_name}</a>,
        },
        {
            header: "Brand Sold",
            filterable: true,
            accessorKey: "brand_sold",
        },
        {
            header: "Price Violation",
            accessorKey: "yesterday_count_price"
        },
        {
            header: "Price Violation Last 7",
            accessorKey: "last_7_days_count_price"
        },
        {
            header: "Price Violation Last Week",
            accessorKey: "last_week_count_price"
        },
        {
            header: "FBA",
            accessorKey: "yesterday_count_fba"
        },
        {
            header: "FBA Last 7",
            accessorKey: "last_7_days_count_fba"
        },
        {
            header: "FBA Last Week",
            accessorKey: "last_week_count_fba"
        }

    ];
    return (
        <Page name={"MAP Enforcement Dashboard"}
              breadCrumbs={<Breadcrumbs items={[{label: "MAP Enforcement"}, {label: "MAP Enforcement Dashboard"}]}/>}>
            <LoadingWrapper loading={loading}>
                <ReactTable
                    filterable
                    data={data}
                    columns={customColumns}
                    initialState={{ pagination: { pageSize: 25 }, sorting: [{ id: "brand_id", desc: false }] }}
                />
            </LoadingWrapper>
        </Page>
    );
}

export default MAPEnforcementDashboard;
